import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin":"2%","font-weight":"bold"} }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "table-transmission table-deductions" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Tipo de hora extra"),
    /*#__PURE__*/_createElementVNode("th", null, "Hora inicio"),
    /*#__PURE__*/_createElementVNode("th", null, "Hora fin"),
    /*#__PURE__*/_createElementVNode("th", null, "Cantidad"),
    /*#__PURE__*/_createElementVNode("th", null, "Pago"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_5 = { class: "p-v-error error-transmission" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-v-error error-transmission" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-v-error error-transmission" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_9 = { class: "p-v-error error-transmission" }
const _hoisted_10 = { class: "tooltip-container" }
const _hoisted_11 = { class: "p-v-error error-transmission" }
const _hoisted_12 = { class: "tooltip-container" }
const _hoisted_13 = { class: "delete-row" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.AgregarFila && $setup.AgregarFila(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'plus-circle'],
          style: {"color":"#00805d"}
        }),
        _createTextVNode(" Adicionar ")
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.HE.items, (horaExtra, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                _createVNode(_component_Dropdown, {
                  showClear: "",
                  class: _normalizeClass(["pv-input-size", {
                'p-invalid':
                  $setup.v$.items.$each.$response.$errors[index].SurchargeTypeCode[0],
              }]),
                  optionLabel: "abreviatura",
                  optionValue: "abreviatura",
                  placeholder: "Seleccione",
                  options: $setup.listaHorasExtras,
                  modelValue: horaExtra.TipoHoraExtra,
                  "onUpdate:modelValue": ($event: any) => ((horaExtra.TipoHoraExtra) = $event),
                  onBlur: ($event: any) => ($setup.AsignarPorcentaje(index, horaExtra.SurchargeTypeCode)),
                  onChange: ($event: any) => ($setup.CodigoHoraExtra(horaExtra.TipoHoraExtra, index))
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onBlur", "onChange", "class"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index]
                    .SurchargeTypeCode, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_Calendar, {
                  modelValue: horaExtra.StartDate,
                  "onUpdate:modelValue": ($event: any) => ((horaExtra.StartDate) = $event),
                  onBlur: $setup.FormatearFechas,
                  class: "pv-input-size",
                  showButtonBar: "",
                  hourFormat: "24",
                  dateFormat: "yy-mm-dd"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                _hoisted_7
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_Calendar, {
                  modelValue: horaExtra.EndDate,
                  "onUpdate:modelValue": ($event: any) => ((horaExtra.EndDate) = $event),
                  onBlur: $setup.FormatearFechas,
                  class: "pv-input-size",
                  showButtonBar: "",
                  hourFormat: "24",
                  dateFormat: "yy-mm-dd"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                _hoisted_8
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  min: 0,
                  inputId: "minmax-buttons",
                  mode: "decimal",
                  class: _normalizeClass(["pv-input-size input-number quantity", {
                'p-invalid':
                  $setup.v$.items.$each.$response.$errors[index].Quantity[0],
              }]),
                  modelValue: horaExtra.Quantity,
                  "onUpdate:modelValue": ($event: any) => ((horaExtra.Quantity) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index]
                    .Quantity, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  min: 0,
                  inputId: "currency-us",
                  mode: "currency",
                  currency: "COP",
                  locale: "es-CO",
                  class: _normalizeClass(["pv-input-size", {
                'p-invalid': $setup.v$.items.$each.$response.$errors[index].Total[0],
              }]),
                  maxFractionDigits: 0,
                  modelValue: horaExtra.Total,
                  "onUpdate:modelValue": ($event: any) => ((horaExtra.Total) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.items.$each.$response.$errors[index].Total, (error) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: error.$uid,
                        visible: error,
                        message: error.$message
                      }, null, 8, ["visible", "message"]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("a", {
                  onClick: ($event: any) => ($setup.EliminarHoraExtra(index))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'minus-circle'],
                    size: "lg"
                  })
                ], 8, _hoisted_14)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}